<template>
  <div class="rpt-content">
    <div style="display: flex; margin-bottom: 40px;">
      <h2 style="margin-right: 20px;">周趋势数据</h2>

      <div class="year-time">
        <div
          class="year-time-item"
          v-for="(item, index) in tab"
          :key="index"
          :class="{ active: num == index }"
          @click="onTabClick(item, index)"
        >
          {{ item }}
        </div>
      </div>
    </div>

    <div id="week-trend"></div>

    <div style="margin: 0 0 30px 0;">
      <el-row :gutter="20">
        <el-col :span="12">
          <div>
            <el-statistic group-separator="," :precision="2" :value="totalAmount" title="预授信金额"></el-statistic>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-statistic group-separator="," :precision="2" :value="totalUser" title="授权用户数"></el-statistic>
          </div>
        </el-col>
      </el-row>
    </div>

    <div>
      <el-table border :data="list" max-height="320" ref="weektable">
        <el-table-column prop="date" label="日期" sortable sort-by="order_num"></el-table-column>
        <el-table-column prop="ysx_amt" label="金额" sortable></el-table-column>
        <el-table-column prop="auth_count" label="授权用户数" sortable></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request';
import { Chart } from '@antv/g2';
export default {
  name: 'home',
  data() {
    return {
      num: 0,
      chart: null,
      nowYear: '',
      tab: ['全部'],
      list: [],
      totalAmount: 0,
      totalUser: 0
    };
  },
  mounted() {
    this.nowYear = new Date().getFullYear();

    for (let i = 2021; i < this.nowYear + 1; i++) {
      this.tab.push(i);
    }
    this.num = this.tab.length - 1;

    this.getdata(`${this.nowYear}0101000000`, `${this.nowYear}1231235959`);
  },
  methods: {
    onTabClick(item, index) {
      this.num = index;
      if (item == '全部') {
        this.num = index;
        this.getdata(`20210101000000`, `${this.nowYear}1231235959`);
      } else {
        this.getdata(`${item}0101000000`, `${item}1231235959`);
      }
    },

    getdata(start, end, num) {
      this.$refs.weektable.clearSort();
      if (num) {
        this.num = num;
      }
      request({ url: `/api/rpt/week/group?begin_datetime=${start}&end_datetime=${end}` }).then(res => {
        if (res.success) {
          if (!this.chart) {
            this.chart = new Chart({
              container: 'week-trend',
              autoFit: true,
              padding: [20, 60, 60, 100]
            });
          }
          this.list = res.result.weekDetailList;
          this.getTotal();
          this.render(res.result.weekDetailList);
        }
      });
    },

    getTotal() {
      this.totalAmount = 0;
      this.totalUser = 0;
      for (let i = 0; i < this.list.length; i++) {
        this.totalAmount += this.list[i].ysx_amt;
        this.totalUser += this.list[i].auth_count;
      }
    },

    render(data) {
      this.chart.data(data);
      this.chart.scale({
        date: {
          alias: '日期'
        },
        auth_count: {
          alias: '授权用户数',
          min: 0,
          sync: true, // 将 字段数值同 time 字段数值进行同步
          nice: true
        },
        ysx_amt: {
          alias: '金额',
          sync: true, // 将 pv 字段数值同 time 字段数值进行同步
          nice: true
        }
      });

      this.chart.axis('auth_count', {
        grid: null,
        title: {}
      });
      this.chart.axis('ysx_amt', {
        title: {}
      });

      this.chart.tooltip({
        showCrosshairs: true,
        shared: true
      });

      this.chart
        .line()
        .position('date*ysx_amt')
        .color('#4FAAEB');
      this.chart
        .line()
        .position('date*auth_count')
        .color('#9AD681')
        .shape('dash');
      this.chart.render();
    }
  }
};
</script>

<style scoped lang="less">
#week-trend {
  height: 340px;
}
.year-time {
  display: flex;
  align-items: center;
}
.year-time-item {
  margin-left: 20px;
  cursor: pointer;
  color: #999;

  &.active {
    color: #333;
    font-weight: bold;
  }
}
</style>
